import {Component, Inject, OnInit} from '@angular/core';
import {DIALOG_DATA, DialogRef} from '@angular/cdk/dialog';
import {FormsModule} from '@angular/forms';


@Component({
  selector: 'app-player-select-audio',
  templateUrl: './player-select-audio.component.html',
  styleUrls: ['./player-select-audio.component.scss'],
  imports: [
    FormsModule
]
})
export class PlayerSelectAudioComponent implements OnInit {
  currentlySelectedRendition: Number;
  renditions: any;
  activeRenditionId: Number;
  streamTypeHLS: boolean;
  streamTypeDASH: boolean;

  constructor(protected dialogRef: DialogRef<Number>,
              @Inject(DIALOG_DATA) data: {
                renditions: any[],
                activeRenditionId: Number,
                streamTypeHLS: boolean,
                streamTypeDASH: boolean
              }) {
    this.renditions = data.renditions;
    this.activeRenditionId = data.activeRenditionId;
    this.currentlySelectedRendition = data.activeRenditionId
    this.streamTypeHLS = data.streamTypeHLS
    this.streamTypeDASH = data.streamTypeDASH
  }

  ngOnInit(): void {
  }
}
